import TarotCardLoader from "./services/TarotCardLoader";
import ProgressBar from "./engine/components/ProgressBar";
import { MainButton } from "./components/MainButton";
import { TarotTable } from "./components/TarotTable";
import EventDispatcher from "./engine/EventDispatcher";
import cardList from "./assets/CardList";
import Transition from "./engine/animations/Transition";
import TarotCard from "./components/TarotCard";
import GlobalState from "./appStates";

export default class AltarApp {
  private mainButton: MainButton;
  private progressBar: ProgressBar;
  private tarotTable: TarotTable;

  private tarotLoader: TarotCardLoader;

  private activeCard: TarotCard | null = null;

  constructor() {
    EventDispatcher.init();
    GlobalState.init();

    this.tarotLoader = new TarotCardLoader();
    this.mainButton = new MainButton();
    this.progressBar = this.mainButton.initProgressBar(cardList.length);
    this.tarotTable = new TarotTable();

    GlobalState.set("activeCard", null);
    
    EventDispatcher.on("card-loader:image-loaded", () => {
      this.progressBar.updateProgress(1);
    })

    EventDispatcher.on("card-loader:completed", () => {
      this.tarotTable.deal(this.tarotLoader.cards);
      this.allowSignIn();
    }, {
      once: true,
    });
  }

  public async init() {
    this.tarotLoader.load();
  }

  public allowSignIn() {
    this.mainButton.showSignInLabel();
    EventDispatcher.on("main-button:clicked", () => {
      this.showTarotCards();
    }, {
      once: true,
    });
  }

  public async showTarotCards() {
    const introLayer = document.getElementById("introduction-layer");
    const introLayerWrapper = document.getElementById("intro-layer-wrapper");

    await this.mainButton.showLogo(1000);
    this.mainButton.explode(800);

    await Transition.circularFadeOut(introLayer).finished;
    introLayer.style.display = "none";

    introLayerWrapper.style.display = "none";

    EventDispatcher.on("main-button:clicked", () => {
      this.toggleView();
    });

    EventDispatcher.on("card:activated", (card: TarotCard) => {
      console.log("Carta", card)
      GlobalState.set("activeCard", card);
      this.mainButton.moveToBottom();
      this.mainButton.showBackIcon();
    });

    EventDispatcher.on("card:deactivated", () => {
      this.activeCard = null;
      this.mainButton.moveToCenter();
      this.mainButton.removeBackIcon();
    });
  }

  public async toggleView() {
    if(GlobalState.get("activeCard") == null) {
      console.log("Toogle view")
    } else {
      (GlobalState.get("activeCard") as TarotCard).deactivate();
      GlobalState.set("activeCard", null);
    }
  }
}
